import React from 'react';

interface PanelProps {
  className?: string;
  outerClassName?: string;
  innerClassName?: string;
  children?: React.ReactNode;
};

const Panel: React.FC<PanelProps> = (props) => {
  return <>
    <div className={`bg-background2 rounded-xl flex p-2 shadow shadow-background2-darker hover:bg-background3 hover:shadow-hover-darker ${props.className ?? ''} ${props.outerClassName ?? ''}`}>
      <div className={`bg-background rounded-xl border border-background-darker w-full ${props.className ?? ''} ${props.innerClassName ?? ''}`}>
        {props.children}
      </div>
    </div>
  </>;
};

export default Panel;
